define('homepage_industries.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('homepage_industries', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/AnchorGroup/HomepageContents/1.0.0/', 'extensions/AnchorGroup/HomepageContents/1.0.0/', Handlebars);
});